import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ServiceSDK"],
    _excluded2 = ["ServiceSDK"];
import createOfferSdk from './offer-sdk/index';
import bankingProductsSDK from './offer-sdk/banking-products';
export var BankingProductsSDK = function BankingProductsSDK(_ref) {
  var ServiceSDK = _ref.ServiceSDK,
      config = _objectWithoutProperties(_ref, _excluded);

  return bankingProductsSDK(ServiceSDK, config);
};
/*
Return an offersSDK library instance.
Note that NWApiSDK instances do hold state, namely "identify" tracking state inside ServiceSDK.

config:
- clientID: your FE app's unique client ID
- offersBaseURL: the offers api base URL for your current environment
*/

export default function (_ref2) {
  var ServiceSDK = _ref2.ServiceSDK,
      config = _objectWithoutProperties(_ref2, _excluded2);

  return createOfferSdk(ServiceSDK, config);
}